import type { IconData } from '@stacksjs/iconify-core'

export const plus: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M440 240H272V72h-32v168H72v32h168v168h32V272h168z\"/>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default plus
